import MetaTags from "react-meta-tags"
import React from "react"
import { Container } from "reactstrap"
import MatureStatus from "../../components/Admin/Mature-Status"

const Mstatus = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Mature Stages | KlikCRM</title>
        </MetaTags>
        <Container fluid>
          <MatureStatus />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Mstatus
